var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0625 2.63093e-07L12.5 9.88934L2.9375 3.50293e-08L1.54492e-07 3.04453L12.5 16L25 3.04453L22.0625 2.63093e-07Z",
    fill: "#0F9D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDownArrow);
export default __webpack_public_path__ + "static/media/GreenDownArrow.bbf7faecd9568678bb3e9cdf71fac32f.svg";
export { ForwardRef as ReactComponent };